// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"91":"78923442","993":"62dfa1a6"}[chunkId] + ".css";
};